import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { HBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { CompanyLabel } from './CompanyLabel';

import { fetchDuplicateVatCompany } from '../actions';
import { selectDuplicateVatCompany } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_DUPLICATE_VAT_COMPANY } from '../constants';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class DoubleVATModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.props.onCancel();
  }

  onSave() {
    this.props.onSave();
  }

  onCompanyOpen(companyId) {
    this.to(`/companies/${companyId}`);
  }

  render() {
    if (this.props.work) {
      <Modal>
        <HBox center vCenter>
          <Loader small />
        </HBox>
      </Modal>;
    }
    return (
      <Modal onClose={this.reset.bind(this)}>
        <p style={{ margin: 0 }}>{this.lbl('company.create.doubleVATMsg')}</p>
        <HBox left vCenter>
          <strong>
            <CompanyLabel company={this.props.company} />
          </strong>
          <Button small onClick={() => this.onCompanyOpen(this.props.company?.id)}>
            {this.lbl('open')}
          </Button>
        </HBox>
        <p style={{ color: 'red' }}>{this.lbl('company.create.doubleVATMsg.saveOrCancelMsg')}</p>
        <ModalControls>
          <Button primary onClick={this.onSave.bind(this)}>
            {this.lbl('save')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

DoubleVATModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  address: PropTypes.object,
  companyId: PropTypes.number,
  standardId: PropTypes.number,
  toggle: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(`${REQUEST_DUPLICATE_VAT_COMPANY}-${ownProps.existsCompanyId}`),
    company: selectDuplicateVatCompany(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchDuplicateVatCompany(ownProps.existsCompanyId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DoubleVATModal = compose(withConnect, withRouter, injectIntl)(DoubleVATModalComp);
